import { render, staticRenderFns } from "./editHotel.vue?vue&type=template&id=1bda4c9a&scoped=true&"
import script from "./editHotel.vue?vue&type=script&lang=js&"
export * from "./editHotel.vue?vue&type=script&lang=js&"
import style0 from "./editHotel.vue?vue&type=style&index=0&id=1bda4c9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bda4c9a",
  null
  
)

export default component.exports